import React from "react";

export default function EditIcon({ color = "currentColor" }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 36 36"
      fill="none"
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.78224 27.6392C7.8626 27.6392 7.94296 27.6312 8.02331 27.6191L14.7813 26.4338C14.8617 26.4178 14.938 26.3816 14.9943 26.3213L32.026 9.28964C32.0632 9.25247 32.0928 9.20832 32.113 9.15972C32.1331 9.11111 32.1435 9.05901 32.1435 9.00639C32.1435 8.95376 32.1331 8.90166 32.113 8.85305C32.0928 8.80445 32.0632 8.7603 32.026 8.72313L25.3483 2.04143C25.272 1.96509 25.1715 1.92491 25.063 1.92491C24.9546 1.92491 24.8541 1.96509 24.7778 2.04143L7.74608 19.0731C7.68581 19.1334 7.64965 19.2057 7.63358 19.2861L6.44831 26.0441C6.40923 26.2593 6.42319 26.4809 6.489 26.6895C6.55481 26.8981 6.67048 27.0876 6.82599 27.2414C7.09117 27.4986 7.42465 27.6392 7.78224 27.6392ZM10.4903 20.6321L25.063 6.0633L28.0081 9.00839L13.4354 23.5771L9.86349 24.2079L10.4903 20.6321ZM32.7854 31.0142H3.21394C2.50278 31.0142 1.92822 31.5888 1.92822 32.2999V33.7463C1.92822 33.9231 2.07287 34.0678 2.24965 34.0678H33.7497C33.9264 34.0678 34.0711 33.9231 34.0711 33.7463V32.2999C34.0711 31.5888 33.4965 31.0142 32.7854 31.0142Z"
        fill="black"
        fillOpacity="0.85"
      />
    </svg>
  );
}
